import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 角色列表
export const setRoleList: Mutation<IModuleState> = (state, payload) => {
  state.roleList.data = payload.data;
  state.roleList.loading = !!payload.loading;
};

// 组织的权限列表
export const setMineAcls: Mutation<IModuleState> = (state, payload) => {
  state.mineAcls.data = payload.data;
  state.mineAcls.loading = !!payload.loading;
};

// 组织的权限列表
export const setOrgAcls: Mutation<IModuleState> = (state, payload) => {
  state.orgAcls.data = payload.data;
  state.orgAcls.loading = !!payload.loading;
};

// 角色的权限列表
export const setRoleAcls: Mutation<IModuleState> = (state, payload) => {
  state.roleAcls.data = payload.data;
  state.roleAcls.loading = !!payload.loading;
};

// 确认弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.data = payload.data;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = !!payload;
};
